/* GENERATED by scripts/experience/generate-design-tokens.ts. DO NOT EDIT. */
export const EXPERIENCE_ARTIFACT_TOKENS = {
  schemaVersion: '1.0.0-candidate.1',
  adapterVersion: '1.0.0-candidate.1',
  colours: {
    'identity.statura.decorative': '#96A998',
    'identity.statura.foreground': '#3E5D4A',
    'identity.statura.hover': '#2F4B3B',
    'identity.tenant.fallback': '#3E5D4A',
    'surface.canvas': '#F8FAFC',
    'surface.base': '#FFFFFF',
    'surface.subtle': '#F5F6F2',
    'surface.inverse': '#0F172A',
    'text.primary': '#1E293B',
    'text.secondary': '#475569',
    'text.body': '#334155',
    'text.muted': '#475569',
    'text.inverse': '#FFFFFF',
    'border.default': '#CBD5E1',
    'border.strong': '#64748B',
    'focus.ring': '#3E5D4A',
    'status.danger': '#991B1B',
    'status.warning': '#92400E',
    'status.success': '#166534',
    'status.information': '#3730A3',
    'workflow.approval': '#6D28D9',
    'domain.finance': '#0369A1',
    'program.sah': '#0F766E',
    'program.rac': '#7E22CE',
  },
  foundation: {
    colours: {
      'action.primary': '#3E5D4A',
      'action.primary-hover': '#2F4B3B',
      'action.primary-foreground': '#FFFFFF',
      'surface.productive': '#F7F8F4',
      'surface.sheet': '#FFFFFF',
      'surface.soft': '#F5F6F2',
      'selection.bg': '#E8EEE9',
      'selection.fg': '#2F4B3B',
      'border.control': '#7B8C7D',
      'focus.control': '#3E5D4A',
    },
    statusPairs: {
      success: {
        fg: '#166534',
        bg: '#F0FDF4',
        fill: '#22C55E',
      },
      warning: {
        fg: '#92400E',
        bg: '#FFFBEB',
        fill: '#F59E0B',
      },
      danger: {
        fg: '#991B1B',
        bg: '#FEF2F2',
        fill: '#EF4444',
      },
      information: {
        fg: '#3730A3',
        bg: '#EEF2FF',
        fill: '#6366F1',
      },
      critical: {
        fg: '#7F1D1D',
        bg: '#FEE2E2',
        fill: '#B91C1C',
      },
      neutral: {
        fg: '#475569',
        bg: '#F1F5F9',
        fill: '#64748B',
      },
    },
    productiveDensity: {
      'page-gutter': '16px',
      'page-gutter-wide': '24px',
      'panel-inset': '20px',
      'panel-inset-compact': '16px',
      'radius-surface': '12px',
      'radius-control': '8px',
      'radius-badge': '4px',
      'radius-tile': '12px',
      'radius-overlay': '12px',
      'control-min-height': '44px',
      'toolbar-min-height': '36px',
      'compact-control-min-height': '32px',
      'table-row-min-height': '44px',
      'section-gap': '32px',
      'elevation-surface': 'none',
      'elevation-menu': '0 4px 6px rgba(15, 23, 42, 0.07)',
      'elevation-popover': '0 6px 12px rgba(15, 23, 42, 0.10)',
      'elevation-dialog': '0 20px 40px rgba(15, 23, 42, 0.12)',
    },
    comfortDensity: {
      'radius-surface': '20px',
      'radius-control': '12px',
      'panel-inset': '28px',
      'elevation-surface': '0 12px 30px rgba(15, 23, 42, 0.06)',
    },
  },
  email: {
    familyStacks: {
      display: ['Merriweather', 'Georgia', 'Times New Roman', 'serif'],
      interface: ['Space Grotesk', 'Inter', 'system-ui', 'sans-serif'],
    },
    permittedWeights: [400, 500, 600, 700],
  },
  pdf: {
    familyStacks: {
      display: ['Merriweather', 'Georgia', 'Times New Roman', 'serif'],
      interface: ['Space Grotesk', 'Inter', 'system-ui', 'sans-serif'],
    },
    permittedWeights: [400, 500, 600, 700],
  },
} as const;
